import React, { useContext } from 'react'

import SearchFloatingPanel, { SearchFloatingPanelProps } from 'components/SearchV2/Components/Mobile/SearchFloatingPanel/SearchFloatingPanel'
import { usePrevious } from '@dnd-kit/utilities'
import useMountedEffect from 'hooks/useMountedEffect'
import FlightSearchWidgetStateContext from 'contexts/Flights/FlightSearchWidget/flightSearchWidgetStateContext'
import noop from 'lib/function/noop'
import FlightSearchAirportSelect from 'components/Flights/FlightsSearch/SearchWidget/FlightAirportSelect/FlightSearchAirportSelect'

interface Props extends
  Omit<
    SearchFloatingPanelProps,
    'title' | 'confirmText' | 'isConfirmButtonHidden' | 'children'
  >
{
  isDeparture?: boolean;
}

function FlightAirportFloatingPanel(props: Props) {
  const { onConfirm = noop, isDeparture } = props

  const { departureAirport, arrivalAirport } = useContext(FlightSearchWidgetStateContext)
  const relevantAirport = isDeparture ? departureAirport : arrivalAirport
  const previousAirport = usePrevious(relevantAirport)

  useMountedEffect(() => {
    if (props.isOpen && previousAirport !== relevantAirport) {
      // It's open and our item has changed, user must've selected something
      // we do it this way because of a timing issue between setting context state and having the updated values
      // the state updates after the event, so we need to listen on the state change
      onConfirm()
    }
  }, [props.isOpen, relevantAirport])

  return (
    <SearchFloatingPanel
      {...props}
      title={isDeparture ? 'Flying from?' : 'Flying to?'}
      isConfirmButtonHidden
    >
      <FlightSearchAirportSelect
        isDeparture={isDeparture}
        title="Search airports"
        inlineSearchOnly
      />
    </SearchFloatingPanel>
  )
}

export default FlightAirportFloatingPanel
